<template>
  <div>
    <product-group-skeleton :layout="layout" v-if="!isComponentReady" />
    <b-row v-else>
      <b-col
        cols="12 mt-2 mt-md-1'"
        :md="group.layout == 'FULL_COLUMN' ? '12' : '6'"
        v-for="(group, index) in filteredProductGroup"
        :key="`productGroup${index}`"
      >
        <div class="d-flex justify-content-between mt-2">
          <h5 class="font-weight-bold text-uppercase text-left">
            <span>
              <b-icon-bag v-if="group.type=='SPECIAL_OFFER'" class="text-primary"/> 
              <b-icon-tag v-if="group.type =='PROMOTION'" class="text-primary"></b-icon-tag>&nbsp;
            </span>
            {{ group.name.slice(0,25) }}
          </h5>
          <b-link @click="$router.push('/product-group/'+group.id)" class="text-primary">View Detail <b-icon-chevron-right></b-icon-chevron-right></b-link>
           <!-- <b-button  variant="light"
            @click="$router.push('/product-group/'+group.id)">View Detail <b-icon-chevron-right></b-icon-chevron-right>
            </b-button> -->
        </div>
        <b-card no-body class="custom-card border-0 shadow-sm">
          <div v-if="group && group.productGroupDetailDTOList">
            <b-row no-gutters>
              <b-col
                :cols="group.layout == 'FULL_COLUMN' ? '12' : '6'"
                :md="group.layout == 'FULL_COLUMN' ? '2' : '0'"
                :class="group.layout == 'HALF_COLUMN' ? 'd-none' : 'd-block'"
               
              >
                <b-img-lazy
                  :src="group.imageUrl || placeholder"
                  :blank-src="placeholder"
                  class="product-group-img"
                >
                </b-img-lazy>
              </b-col>
              <template v-if="group.layout == 'FULL_COLUMN'">
                <b-col
                :cols="group.layout == 'FULL_COLUMN' ? '6' : '4'"
                :md="group.layout == 'FULL_COLUMN' ? '2' : '4'"
                v-for="groupDetail in group.productGroupDetailDTOList.slice(0,11)"
                :key="groupDetail.id"
              >
                <product-item
                  class="mt-3"
                  :product="groupDetail.product"
                  :showSeller="false"
                  :simpleItem="true"
                ></product-item>
              </b-col>
              </template>
              <!-- MULTIPLE TEMPLATE ERROR CAN'T SOLVE -->
              <template v-if="group.layout == 'HALF_COLUMN'">
                <b-col
                :cols="group.layout == 'FULL_COLUMN' ? '6' : '4'"
                :sm="group.layout == 'FULL_COLUMN' ? '6' : '4'"
                :md="group.layout == 'FULL_COLUMN' ? '2' : '4'"
                v-for="groupDetail in group.productGroupDetailDTOList.slice(0,3)"
                :key="groupDetail.id"
              >
                <product-item
                  class="mt-3 mt-md-1"
                  :product="groupDetail.product"
                  :showSeller="false"
                  :simpleItem="true"
                ></product-item>
              </b-col>
              </template>
            </b-row>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BCard, BImgLazy, BIconChevronRight, BIconBag,BIconTag, BLink } from "bootstrap-vue";
import productGroupService from "../../services/productGroup.service";
import ProductItem from "../productItem.vue";
import ProductGroupSkeleton from "../skeletons/ProductGroupSkeleton.vue"
export default {
  components: {
    BCard,
    BImgLazy,
    BIconChevronRight,
    ProductItem,
    ProductGroupSkeleton,
    BIconBag,
    BIconTag,
    BLink
  },
  props: {
    type: {
      type: String,
    },
    layout:{
      type: String
    }
  },
  data: () => ({
    productGroups: [],
    placeholder: require("../../assets/images/yoma-placeholder.png"),
    isComponentReady: false
  }),
  mounted() {
    this.getProductGroupList();
  },
  methods: {
    async getProductGroupList() {
      try {
        const res = await productGroupService.getProductGroupByStatus("ACTIVE");
        this.productGroups = res.data;
        this.productGroups =  this.productGroups.filter((item)=>{
          return item.hide === false;
        })
         this.isComponentReady = true;
      } catch (error) {
        console.error(error);
      }
    },
  },
  computed: {
    filteredProductGroup() {
      return this.productGroups.filter((group) =>
        this.type.includes(group.type)
      );
    },
  },
};
</script>
